import React from 'react';
import { Link } from 'react-router-dom';

import { Button, IconButton } from '@mui/material';

import SignInIcon from './assets/sign-in.svg';
import useStyles from './styles';

interface Props {
    compact?: boolean;
    className?: string;
}

const SignInButton: React.FC<Props> = ({ compact, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.container, className)}>
            {compact ? (
                <IconButton
                    disableRipple
                    disableFocusRipple
                    component={Link}
                    to={'/login'}
                    className={cx(classes.compact)}
                >
                    <SignInIcon />
                </IconButton>
            ) : (
                <Button
                    fullWidth
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    variant="contained"
                    component={Link}
                    to={'/login'}
                    endIcon={<SignInIcon />}
                    className={cx(classes.regular)}
                >
                    {'Sign in'}
                </Button>
            )}
        </div>
    );
};

export default SignInButton;
